import React from 'react';

const Counter = props => {
  return <span>Counter: {props.counter}</span>;
};

export default Counter;
